import { Col, Row } from 'react-grid-system';
import { Field, reduxForm } from 'redux-form/immutable';
import { TextField } from 'redux-form-material-ui';
import { stitch } from 'keo';
import FlatButton from 'material-ui/FlatButton';
import PropTypes from 'prop-types';
import r from 'render-dom';

const style = {
    action: {
        marginBottom: -15,
        paddingTop: 10,
        textAlign: 'right',
    },
};

const propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    resetCode: PropTypes.string,
};

const render = ({
    props: {
        handleSubmit,
        resetCode,
    }
}) => {
    return (
        r.form({ onSubmit: handleSubmit }, [
            r.div({ isRendered: !resetCode }, [
                r(Field, {
                    component: TextField,
                    floatingLabelText: 'Email',
                    fullWidth: true,
                    name: 'email',
                }),
                r(Row, { style: style.action }, [
                    r(Col, {
                        offset: { xs: 6 },
                        xs: 6,
                    }, [
                        r(FlatButton, {
                            label: 'Submit',
                            primary: true,
                            type: 'submit',
                        }),
                    ]),
                ]),
            ]),
            r.div({ isRendered: resetCode }, [
                r(Field, {
                    component: TextField,
                    floatingLabelText: 'Password',
                    fullWidth: true,
                    name: 'password',
                    type: 'password',
                }),
                r(Field, {
                    component: TextField,
                    floatingLabelText: 'Repeat Password',
                    fullWidth: true,
                    name: 'passwordRepeat',
                    type: 'password',
                }),
                r(Row, { style: style.action }, [
                    r(Col, {
                        offset: { xs: 6 },
                        xs: 6,
                    }, [
                        r(FlatButton, {
                            label: 'Submit',
                            primary: true,
                            type: 'submit',
                        }),
                    ]),
                ]),
            ]),
        ])
    );
};

export default reduxForm({ form: 'reset' })(stitch({ propTypes, render }));



// WEBPACK FOOTER //
// ./src/components/shared/PasswordReset/PasswordReset.js